import $ from "jquery";
import ko from "knockout";
import uly from "ulysses/base";
import HalResource from "ulysses/api";
import "ulysses/pubsub";

var entity_cache = {};
function add_to_cache(identity, deferred) {
    if (!entity_cache[identity]) {
        var sub = uly.subscribeToChange(identity, function() {
            remove_from_cache(identity);
        });
        entity_cache[identity] = { def: deferred, sub:sub };
    } else {
        entity_cache[identity].def = deferred;
    }
}

function remove_from_cache(identity) {
    var val = entity_cache[identity];
    if (val && val.sub) {
        uly.unsubscribeToChange(identity, val.sub);
    }
    delete entity_cache[identity];
}

function clear_cache() {
    var to_delete = [];
    for (var key in entity_cache) {
        to_delete.push(key);
    }
    to_delete.forEach((key) => {
        remove_from_cache(key);
    })
}

$.extend(uly.api, {
    clear_entity_cache: function() {
        clear_cache();
    },
    //Convenience methods for loading data entities
    fetch_entity: function fetch_entity(unique_id) {
        return uly.api.start()
            .follow("uly:search")
            .follow("uly:results", {"q":{"_search_body": "id:"+unique_id}})
            .follow("item").then(function(results) {
                var q = Promise.Deferred();
                if (results.length) {
                    q.resolve(results[0]);
                } else {
                    q.reject({"success":false, "error": _("entity_service_error_resource_not_found", "Resource not found")});
                }
                return q;
            });
    },
    fetch_entities: function fetch_entities(unique_ids) {
        var filters = unique_ids.map(function(v) {
            return "id:"+v;
        }).join(" OR ");
        return uly.api.start()
            .follow("uly:search")
            .follow("uly:results", {"q":{"filter":filters}})
            .follow("item");
    },
    get_resource: function fetch_resource(relurl_or_segments) {
        var segments = relurl_or_segments;
        if (typeof relurl_or_segments === "string") {
            segments = relurl_or_segments.split("/");
        }

        var entry_point = segments[0];
        var rel = "data";
        if (entry_point in uly.api.routes) {
            rel = entry_point;
            segments = segments.slice(1,segments.length);
        }
        //replace data urls to search ones.
        if (rel === "data") {
            if (segments.length == 1) {
                if (segments[0].indexOf("#") == -1) {
                    //searching by alias or root entity collection
                    //not sure what to do right now, punting to old behaviour.
                    return uly.api.start().follow("uly:data").follow("find", {"rel":segments[0], "nodata":1});
                    //return uly.api.search({q:{filter:"url_alias:"+segments[0]}}).follow("item").then(function(results) {
                    //   if (results && results.length) return results[0];
                    //    throw "No resource found";
                    //});
                } else {
                    return uly.api.get_entity(segments[0]);
                }
            } else if (segments.length == 2) {
                return uly.api.get_entity(segments[0], segments[1]);
            } else {
                console.log("more segments, falling back to classic");
            }
        }
        var def = uly.api.start().follow("uly:"+rel);
        if (rel == "data" && segments.length >= 2) {
            var model = segments[0];
            var id = segments[1];
            def = def.follow("uly:entity", { "model":model, "id":id });
            segments = segments.slice(2);
        }
        $.each(segments, function(idx, segment) {
            if (segment.length > 0)
                def = def.follow("find", { "rel":segment });
        });
        return def;
    },
    "get_entity":function(fullid_or_type, maybe_id) {
        var identity,filter;
        if (fullid_or_type.indexOf("#") > 0) {
            filter = "id:"+fullid_or_type;
            identity = fullid_or_type.toLowerCase();
        } else {
            filter = "_type:" + fullid_or_type.toLowerCase() + " AND id_s:"+maybe_id;
            identity = [fullid_or_type, maybe_id].join("#").toLowerCase();
        }
        if (entity_cache[identity]) {
            return entity_cache[identity].def;
        } else {
            add_to_cache(identity, uly.api.start()
                .follow("uly:search")
                .follow("uly:results", {"q":{"_search_body":filter}, "rights_key":identity})
                .follow("item")
                .then(function(items) {
                    if (items.length) {
                        $.each(items, function(idx,val) {
                            var def = Promise.Deferred();
                            def.resolve(val);
                            if (val.unique_id) {
                                add_to_cache(val.unique_id.toLowerCase(), def);
                            }
                            return def;
                        });
                        return entity_cache[identity].def;
                    } else {
                        remove_from_cache(identity);
                        throw _("entity_service_resource_not_found", "Resource not found");
                    }
                }, function(error) {
                    remove_from_cache(identity);
                    return error;
                }));
            return entity_cache[identity].def;
        }
    },
    "get_entities": function(fullids_or_type, maybe_ids) {
    }
});
